import { render } from "./SearchResultsPage.vue?vue&type=template&id=d53f0c1e&scoped=true"
import script from "./SearchResultsPage.vue?vue&type=script&lang=js"
export * from "./SearchResultsPage.vue?vue&type=script&lang=js"

import "./SearchResultsPage.vue?vue&type=style&index=0&id=d53f0c1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d53f0c1e"]])

export default __exports__